import {createTheme} from "@mui/material";

const light = createTheme({
    typography: {
        fontFamily: 'TacTicsSans'
    },
    shape: {
        borderRadius: 0
    },
    palette: {
        mode: 'light',
        primary: {
            main: '#ff6100'
        },
        secondary: {
            main: '#ff6100'
        },
        background: {
            default: '#ededed',
            paper: '#ffffff'
        },
        text: {
            secondary: '#828395',
            primary: '#2f2f2f'
        },
        light: {
            secondary: 'rgba(255,97,0,0.3)'
        }
    }
});


const dark = createTheme({
    typography: {
        fontFamily: 'TacTicsSans'
    },
    shape: {
        borderRadius: 0
    },
    palette: {
        mode: 'dark',
        background: {
            paper: '#212121',
            default: '#141414'
        },
        primary: {
            main: '#ffffff'
        },
        secondary: {
            main: '#ff6100'
        },
        text: {
            primary: '#ffffff',
            secondary: 'rgba(141,141,141,0.7)'
        },
        light: {
            secondary: 'rgba(255,97,0,0.3)'
        }
    },
});

export const THEMES = {light, dark};
